import { AbstractControl, FormGroup, ValidationErrors } from '@angular/forms';
import { PeselUtils } from '../../../../utils/pesel.utils';
import { BeneficiaryDetailsFormModel } from '../form-group/beneficiary-details-form.model';
import {
  kobietaStanCwyilny,
  mezczyznaStanCwyilny,
  StanCywilny,
} from '../../../../enums/stan-cywilny.enum';
import { Plec } from '../../../../enums/plec.enum';

export class CustomValidatorsBeneficiaryDetails {
  public static peselValid(control: AbstractControl): ValidationErrors | null {
    if (!control.value) return null;
    return PeselUtils.decode(control.value).isValid
      ? null
      : { invalidPesel: true };
  }

  public static plecValidator(
    control: AbstractControl,
  ): ValidationErrors | null {
    const fg = control as FormGroup<BeneficiaryDetailsFormModel>;
    if (!fg) return null;

    const plec = fg.controls.plec.value;
    const pesel = PeselUtils.decode(fg.controls.pesel.value);

    if (plec == null || !pesel.isValid) return null;

    return plec === pesel.sex ? null : { peselPlecInvalid: true };
  }

  public static stanCywilnyPlecValidator(
    control: AbstractControl,
  ): ValidationErrors | null {
    const fg = control as FormGroup<BeneficiaryDetailsFormModel>;
    if (!fg) return null;

    const plec = fg.controls.plec.value;
    const stanCwyilny = fg.controls.stanCywilny.value;

    if (plec == null || stanCwyilny == null) return null;

    const validate =
      plec === Plec.MEZCZYZNA
        ? mezczyznaStanCwyilny().includes(stanCwyilny.nazwa! as StanCywilny)
        : kobietaStanCwyilny().includes(stanCwyilny.nazwa! as StanCywilny);

    return validate ? null : { stanCywilnyPlecInvalid: true };
  }
}
